import { SpaceShip } from "./SpaceShip";

export class Size {
    id: "small" | "medium" | "large";
    weight: number;

    public static SMALL: Size = {
        id: "small",
        weight: 1
    };

    public static MEDIUM: Size = {
        id: "medium",
        weight: 2
    };

    public static LARGE: Size = {
        id: "large",
        weight: 3
    };

    public static Sizes: Size[] = [
        Size.LARGE,
        Size.MEDIUM,
        Size.SMALL
    ];
}

export class LandingPad extends Phaser.GameObjects.Sprite {
    size: Size;
    state: "empty" | "fueling" | "ready" | "waiting";


    constructor(scene: Phaser.Scene, x: number, y: number, texture: string, frame: number, size: Size) {
        super(scene, x, y, texture, frame);
        this.size = size;
        this.state = "empty";

        this.setInteractive();
        this.scene.add.existing(this);
    }

}



// WEBPACK FOOTER //
// ./src/games/SpacePortGame/objects/LandingPad.ts